import { render, staticRenderFns } from "./DashboardWidgetAnalisiRedditualeConsuntiva.vue?vue&type=template&id=6afc3e56&"
import script from "./DashboardWidgetAnalisiRedditualeConsuntiva.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetAnalisiRedditualeConsuntiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports